import { Injectable } from '@angular/core';
import {Observable} from "rxjs";
import {catchError, tap} from "rxjs/operators";
import { HttpClient, HttpParams } from "@angular/common/http";
import {MatSnackBar} from "@angular/material/snack-bar";
import {HelperService} from "../helper.service";
import {BaseService} from "./base.service";
import { Group } from '../models/group';
import { PageModel } from '../models/page-model';
import { AllSamplesGroupModel } from '../models/all-samples-group-model';
import { SampleGroupInfo } from '../models/Sample-Group-Info';
import { SampleGroupField } from '../models/sample-group-field';

@Injectable({
  providedIn: 'root'
})
export class GroupService extends BaseService {

  private API_PIN_MANAGEMENT_URL = this.API_BASE_URL + "pin-management"; 

  constructor(
      private httpClient: HttpClient,
      public snackBar: MatSnackBar,
      public helper: HelperService,
  ) {
    super();
  }

  /// GET ///
      getPaginatedGroupListByTenantId(tenantId:number, page: number, size: number,searchQuery:string, fromDate:string, toDate: string, pinTypeId?: any): Observable<PageModel<Group[]>> {

        let params = new HttpParams()
            .set('page', page.toString())
            .append('size', size.toString())
    
        if (tenantId) {
            params = params.append('tenantId', tenantId.toString());
        }

        if (searchQuery) {
            params = params.append('searchQuery', searchQuery);
        }
    
        if (fromDate) {
            params = params.append('fromDate', fromDate);
        }
    
        if (toDate) {
            params = params.append('toDate', toDate);
        }

        if (pinTypeId) {
            params = params.append('pinTypeId', pinTypeId.toString());
        }
    
        return this.httpClient.get<PageModel<Group[]>>(this.API_PIN_MANAGEMENT_URL + `/samplegroups`, {params})
            .pipe(
                catchError((err) => {
                    this.hasError.next(true);
                    this.snackBar.open('Error Retrieving All Pin List','close', {
                        duration: 5000,
                    });
                    this.hasError.next(false);
                    return this.errorHandler(err);
                })
            );
    }


        getPaginatedGroupGriidingListByFieldId(fieldId:number, page?: number, size?: number, date?: string): Observable<PageModel<SampleGroupInfo[]>> {

        let params = new HttpParams()
            .set('page', page.toString())
            .append('size', size.toString())
    
        if (date) {
            params = params.append('date', date.toString());
        }
        return this.httpClient.get<PageModel<SampleGroupInfo[]>>(this.API_PIN_MANAGEMENT_URL + `/samplegroups?fieldId=${fieldId}`, {params})
            .pipe(
                catchError((err) => {
                    this.hasError.next(true);
                    this.snackBar.open('Error Retrieving All Sample Groups By Farm','close', {
                        duration: 5000,
                    });
                    this.hasError.next(false);
                    return this.errorHandler(err);
                })
            );
    }

    getHistoricPinDetailsForGriidingBySampleGroupId(sampleGroupId:number): Observable<any> {

 
        return this.httpClient.get<any>(this.API_PIN_MANAGEMENT_URL + `/samplegroups/${sampleGroupId}/pins`)
            .pipe(
                catchError((err) => {
                    this.hasError.next(true);
                    this.snackBar.open('Error Retrieving Sample Group Pin Details By sample group ','close', {
                        duration: 5000,
                    });
                    this.hasError.next(false);
                    return this.errorHandler(err);
                })
            );
    }

    /**
     * Fields that the pins in a sample group sit in, with their boundary geometry.
     *
     * Needs GET /pin-management/samplegroups/{id}/fields on pin-management-api.
     * There is no existing endpoint that returns boundaries for the fields in a
     * group: farm-management only exposes them per farm or per field, so without
     * this the map would need one request per field.
     *
     * **Deliberately silent to the user.** Unlike every other call in this file,
     * a failure here raises no snackbar and does not set `hasError`. The
     * boundaries are decoration on a map that is perfectly usable without them,
     * and the caller already falls back to drawing pins alone. The endpoint does
     * not exist yet, so until it ships this call fails on every page load, and a
     * red banner on every open would train people to ignore real errors.
     *
     * It is not swallowed: the error is logged and still thrown, so the caller
     * chooses the fallback rather than having one imposed here. Remove the
     * console warning once the endpoint is live.
     */
    getSampleGroupFields(sampleGroupId:number): Observable<SampleGroupField[]> {

        return this.httpClient.get<SampleGroupField[]>(this.API_PIN_MANAGEMENT_URL + `/samplegroups/${sampleGroupId}/fields`)
            .pipe(
                catchError((err) => {
                    console.warn('Sample group field boundaries unavailable, drawing pins only.', err);
                    return this.errorHandler(err);
                })
            );
    }

    getGroups(tenantId:number): Observable<any[]> {
      
      

        return this.httpClient.get<any[]>(this.API_PIN_MANAGEMENT_URL + `/samplegroups/dropdown?tenantId=${tenantId}`)
            .pipe(
                catchError((err) => {
                    this.hasError.next(true);
                    this.snackBar.open('Error Retrieving Group List','close', {
                        duration: 5000,
                    });
                    this.hasError.next(false);
                    return this.errorHandler(err);
                })
            );
    }
  //POST
    postNewGroup(userId: number, tenantId:number, name: string): Observable<any> {
        const body = {
          userId: userId,
          tenantId: tenantId,
          name: name,
        }
        

        return this.httpClient.post<any>(this.API_PIN_MANAGEMENT_URL + `/samplegroups`, body)
            .pipe(
                catchError((err) => {
                    this.hasError.next(true);
                    this.snackBar.open('Error Creating New Group','close', {
                        duration: 5000,
                    });
                    this.hasError.next(false);
                    return this.errorHandler(err);
                })
            );
    }



      //PUT
  updateMergeSampleGroups(groupId: number, mergeWithId: number): Observable<any> {
    const body = {}
    return this.httpClient.put<any>(this.API_PIN_MANAGEMENT_URL + `/samplegroups/${groupId}/merge?mergeWithId=${mergeWithId}` , body)
        .pipe(
            catchError((err) => {
              this.hasError.next(true);
              this.snackBar.open('Error Merging Sample Groups','close', {
                duration: 5000,
              });
              this.hasError.next(false);
              return this.errorHandler(err);
            }),
            tap(() => {
              this.snackBar.open('Merge Successful', 'close', {
                duration: 5000,
              });
            })
        );
  }

  updateSampleGroups(
            groupId:number,
            name:string,
            isGrid:boolean,
            gridRotation:number,
            gridSpacing:number,
            tenantId:number,
            userId:number,
  ): Observable<SampleGroupInfo> {

    const body = {
            groupId: groupId,
            name:name,
            isGrid:isGrid,
            gridRotation:gridRotation,
            gridSpacing:gridSpacing,
            tenantId:tenantId,
            userId:userId,
          }


          console.log(body, 'sample group body');
          
    return this.httpClient.put<SampleGroupInfo>(this.API_PIN_MANAGEMENT_URL + `/samplegroups/${groupId}` , body)
        .pipe(
            catchError((err) => {
              this.hasError.next(true);
              this.snackBar.open('Error Updating Sample Groups','close', {
                duration: 5000,
              });
              this.hasError.next(false);
              return this.errorHandler(err);
            }),
            tap(() => {
              this.snackBar.open('Update Successful', 'close', {
                duration: 5000,
              });
            })
        );
  }


//       // DELETE ///
  deleteGroupById(id: number): Observable<any> {
    
    return this.httpClient.delete(this.API_PIN_MANAGEMENT_URL + `/samplegroups/${id}`)
        .pipe(
            catchError((err) => {
              this.hasError.next(true);
              this.snackBar.open('Error Removing Sample Group','close', {
                duration: 5000,
              });
              this.hasError.next(false);
              return this.errorHandler(err);
            }),
            tap(() => {
              this.snackBar.open('Sample Group Removed Successfully', 'close', {
                duration: 5000,
              });
            })
        );
  }
}



  